import PropTypes from 'prop-types'
import {
  DIAS_AVISO_VENCIMIENTO,
  ESPERANDO_PAGO_TEXTO,
  ESTADO_PAUSADA,
  ESTADO_PUBLICADA,
  ESTADO_VENCIDA,
  mensajeAvisoVence,
  mensajeAvisoVencido
} from '../../../constants/publicaciones.js'
import {
  avisoProximoAVencer,
  calcularDiasHastaFecha,
  validarRangoFechas
} from '../../../helpers/dateValidation.js'
import { formatearFecha } from '../../helpers/helper.js'
import GenericSelect from '../../reutilizables/genericSelect/GenericSelect'
import styles from './Estado.module.css'

const ESTADO = [
  { idPublicacionEstado: ESTADO_PUBLICADA, nombre: 'Publicada' },
  { idPublicacionEstado: ESTADO_PAUSADA, nombre: 'Pausada' },
  { idPublicacionEstado: ESTADO_VENCIDA, nombre: 'Vencida' }
]

const Estado = ({
  value,
  onChange,
  vigenciaHasta,
  fechaReactivacion,
  estadoInicial,
  fechaVencimientoAviso,
  esperandoPago = false
}) => {
  const selectDeshabilitado =
    estadoInicial === ESTADO_VENCIDA &&
    validarRangoFechas(new Date(vigenciaHasta), new Date(), 'day')

  const estaPausadaAutomaticamente =
    value === ESTADO_PAUSADA &&
    fechaReactivacion &&
    validarRangoFechas(new Date(), new Date(fechaReactivacion), 'second')

  const fechaReactivacionFormateada = formatearFecha(fechaReactivacion, 'FH')

  const diasParaVencerAviso = calcularDiasHastaFecha(fechaVencimientoAviso)

  const estaVencida = value === ESTADO_VENCIDA

  const mostrarAvisoProximoAVencer =
    !estaVencida && avisoProximoAVencer(fechaVencimientoAviso, DIAS_AVISO_VENCIMIENTO)

  const avisoVencido = !estaVencida && diasParaVencerAviso !== null && diasParaVencerAviso < 0

  const fechaVencimientoFormateada = formatearFecha(fechaVencimientoAviso, 'FaH')

  return (
    <div className={styles.container}>
      <span className={styles.label}>Cambiar estado a:</span>
      <GenericSelect
        name="idPublicacionEstado"
        onChange={(val) =>
          onChange(
            {
              currentTarget: { name: 'idPublicacionEstado', value: val, type: 'select' }
            },
            'num'
          )
        }
        value={value}
        className={styles.select}
        options={ESTADO.map((e) => ({
          value: e.idPublicacionEstado,
          label: e.nombre,
          key: e.idPublicacionEstado
        }))}
        placeholder="Seleccionar estado"
        disabled={selectDeshabilitado || estaPausadaAutomaticamente || esperandoPago}
      />
      {esperandoPago && <small className="warningMessage">{ESPERANDO_PAGO_TEXTO}</small>}
      {selectDeshabilitado && (
        <small className="warningMessage">
          Para modificar el estado de la publicación, es necesario actualizar la fecha de vigencia a
          un día posterior al actual.
        </small>
      )}
      {estaPausadaAutomaticamente && (
        <small className="warningMessage">
          La publicación se reactivará automáticamente el {fechaReactivacionFormateada} y no puede
          modificarse el estado hasta entonces.
        </small>
      )}
      {mostrarAvisoProximoAVencer && (
        <small className="warningMessage">{mensajeAvisoVence(fechaVencimientoFormateada)}</small>
      )}
      {avisoVencido && (
        <small className="warningMessage">{mensajeAvisoVencido(fechaVencimientoFormateada)}</small>
      )}
    </div>
  )
}

Estado.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  vigenciaHasta: PropTypes.string.isRequired,
  fechaReactivacion: PropTypes.string,
  estadoInicial: PropTypes.number.isRequired,
  fechaVencimientoAviso: PropTypes.string,
  esperandoPago: PropTypes.bool
}

export default Estado
